type MarginChartBounds = {
    marginPercentageData: any[];
    groupedChartData: any[];
    minMarginPercent: number;
    maxMarginPercent: number;
    minVolumeSalesEquivalent: number;
    maxVolumeSalesEquivalent: number;
};

const EMPTY_MARGIN_CHART_BOUNDS: MarginChartBounds = {
    marginPercentageData: [],
    groupedChartData: [],
    minMarginPercent: 0,
    maxMarginPercent: 0,
    minVolumeSalesEquivalent: 0,
    maxVolumeSalesEquivalent: 0,
};

export function isMarginHierarchyQueryEnabled(
    allDimAndAttributeTypeList: any,
    timePeriodLoading: boolean,
    idForRestOfComponentLoading: boolean,
    timePeriodSelection: any,
) {
    return Boolean(
        allDimAndAttributeTypeList &&
            'loading' in allDimAndAttributeTypeList &&
            !timePeriodLoading &&
            !idForRestOfComponentLoading &&
            timePeriodSelection,
    );
}

export function buildMarginPercentageChartData(
    allData: any[],
    allVolumeEquivalentData: any[],
    profitPoolTierList: any[],
): MarginChartBounds {
    if (!allData.length || !allVolumeEquivalentData.length) {
        return EMPTY_MARGIN_CHART_BOUNDS;
    }

    let minMarginPercent = Number.POSITIVE_INFINITY;
    let maxMarginPercent = Number.NEGATIVE_INFINITY;
    let minVolumeSalesEquivalent = Number.POSITIVE_INFINITY;
    let maxVolumeSalesEquivalent = Number.NEGATIVE_INFINITY;
    const attributeMap = new Map();

    const finalChartData = allData.map((item: any) => {
        const currentMarginPercent = item.kpi_values?.margin_percentage || 0;
        if (currentMarginPercent < minMarginPercent) minMarginPercent = currentMarginPercent;
        if (currentMarginPercent > maxMarginPercent) maxMarginPercent = currentMarginPercent;

        const volumeSalesEquivalent =
            allVolumeEquivalentData.find(
                (volumeEquivalentItem: any) => volumeEquivalentItem.attribute_ex_id === item.attribute_ex_id,
            )?.kpi_values?.volume_sales_equivalent || 0;
        if (volumeSalesEquivalent < minVolumeSalesEquivalent) minVolumeSalesEquivalent = volumeSalesEquivalent;
        if (volumeSalesEquivalent > maxVolumeSalesEquivalent) maxVolumeSalesEquivalent = volumeSalesEquivalent;

        const createdObj = {
            attribute_ex_id: item.attribute_ex_id,
            attributeDesc: item.attribute_desc,
            marginPercent: currentMarginPercent || 0,
            volume_sales_equivalent: volumeSalesEquivalent || 0,
            tierReference: item.tier,
            tier: profitPoolTierList.find((t: any) => t.tierReference === item.tier)?.tierName,
        };

        if (!attributeMap.has(item.attribute_ex_id)) {
            attributeMap.set(item.attribute_ex_id, []);
        }
        const currentAttributeVal = attributeMap.get(item.attribute_ex_id);
        currentAttributeVal.push(createdObj);
        attributeMap.set(item.attribute_ex_id, currentAttributeVal);

        return createdObj;
    });

    return {
        marginPercentageData: finalChartData,
        groupedChartData: Array.from(attributeMap.values()),
        minMarginPercent: minMarginPercent === Number.POSITIVE_INFINITY ? 0 : minMarginPercent,
        maxMarginPercent: maxMarginPercent === Number.NEGATIVE_INFINITY ? 0 : maxMarginPercent,
        minVolumeSalesEquivalent:
            minVolumeSalesEquivalent === Number.POSITIVE_INFINITY ? 0 : minVolumeSalesEquivalent,
        maxVolumeSalesEquivalent:
            maxVolumeSalesEquivalent === Number.NEGATIVE_INFINITY ? 0 : maxVolumeSalesEquivalent,
    };
}
